import React from 'react';
import ReactDOM from 'react-dom';

import Root from './root';
import store from './redux/store';

// import registerServiceWorker from './registerServiceWorker';
import registerGlobals from 'app/utils/registerGlobals';

import 'babel-polyfill';

import './styles-common/base.css';

const render = Component => {
  ReactDOM.render(<Component store={store} />, document.getElementById('root'));
};

render(Root);

registerGlobals();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js